import React from "react";
import {
  Button,
  Form,
  Heading,
  Modal,
  Text
} from 'blueprints2';
import { FormattedMessage } from 'react-intl';

function DeleteCredential({ visible, setVisible, values, deleteCred }) {
  return (
    <Modal
      isVisible={visible}
      onClose={() => setVisible(false)}>
      <Heading level={3}>
        <FormattedMessage id="applications.form.delete.title"/>
      </Heading>
      <div className="border-b border-gray-400"></div>
      <Form 
        values={values}
        onSubmit={(e) => deleteCred(e)}>
        <Text className="form__text--delete">
          <FormattedMessage id="applications.form.delete.body"/>
        </Text>
        <Button type="submit">
          <FormattedMessage id="applications.form.delete.submit"/>
        </Button>
        <Button isSecondary onClick={() => setVisible(false)}>
          <FormattedMessage id="applications.form.cancel"/>
        </Button>
      </Form>
    </Modal>
  );
}

export default DeleteCredential;